export default {
  actions: {
    createLocation({ commit }, location) {
      this.$authorize('edit', 'Opportunity')
      const opportunity = location.opportunity

      // Accepts address or id in location
      return Vue.$http
        .post(`admin/opportunities/${location.opportunity.id}/locations`, { location })
        .then(response => {
          const locations = response.data
          commit('setLocations', { opportunity, locations })
        })
    },
    removeLocation({ commit }, location) {
      this.$authorize('edit', 'Opportunity')
      const opportunity = location.opportunity

      return Vue.$http
        .delete(`admin/opportunities/${location.opportunity.id}/locations/${location.id}`)
        .then(response => {
          const locations = response.data
          commit('setLocations', { opportunity, locations })
        })
    },
    updateLocation({ commit }, location) {
      this.$authorize('edit', 'Opportunity')
      const opportunity = location.opportunity

      return Vue.$http
        .patch(`admin/opportunities/${location.opportunity.id}/locations/${location.id}`, {
          location,
        })
        .then(response => {
          const locations = response.data
          commit('setLocations', { opportunity, locations })
        })
    },
  },
}
